module.exports = __webpack_public_path__ + "static/media/DSC01476.d6bb656e.jpg";